export default __webpack_public_path__ + "static/AvenirLTStd-BookOblique-d4bb25d5ee845dabea4e0c5ec72560e0.woff";